import { memo, useEffect, useState } from "react";
import useLocalStorageState from "use-local-storage-state";
import { MaintenanceButton } from "../MaintenanceButton";
import { MaintenanceModal } from "../MaintenanceModal";

export const Maintenance = memo(() => {
  const [ wasShown, setWasShown ] = useLocalStorageState("maintenanceNoticeShown", {
    defaultValue: false,
  });

  const [ isOpen, setIsOpen ] = useState(false);


  useEffect(() => {
    if (!wasShown) {
      setIsOpen(true);
    }
  }, [ wasShown ]);

  return (
    <>
      <MaintenanceButton
        onClick={() => setIsOpen(true)}
      />
      <MaintenanceModal
        isOpen={isOpen}
        onRequestClose={() => {
          setIsOpen(false);
          setWasShown(true);
        }} />
    </>
  );
});